/**
 * Theme constants for consistent styling across the application
 * Uses CSS variables with fallback values
 */
export const theme = {
  colors: {
    // Background colors
    pageSubtle: "var(--color-page-subtle,#0d0f1c)",
    backgroundNeutralSubtlest:
      "var(--color-background-neutral-subtlest,#131d2d)",

    // Border colors
    borderNeutralSubtlest: "var(--color-border-neutral-subtlest,#4a4c59)",
    borderSecondarySubtlest: "var(--color-border-secondary-subtlest,#293950)",
    borderPrimarySubtle: "var(--color-border-primary-subtle,#5e6dff)",
    borderSecondaryDecorative:
      "var(--color-border-secondary-decorative,#f2f4f8)",

    // Text colors
    foregroundNeutralBold: "var(--color-foreground-neutral-bold,white)",
    foregroundNeutralSubtle: "var(--color-foreground-neutral-subtle,#9ea1b1)",
    foregroundSecondaryBold: "var(--color-foreground-secondary-bold,#f3f4f7)",
    foregroundPrimaryMedium: "var(--color-foreground-primary-medium,#b2bcff)",
    foregroundWarningMedium: "var(--color-foreground-warning-medium,#a36a00)",
  },

  spacing: {
    sectionGap: "gap-6", // 24px
    fieldGap: "gap-1", // 4px
    containerPadding: "py-6",
    sectionPadding: "px-16 py-2",
    headerPadding: "py-2 p-4",
  },

  typography: {
    h1: "text-[32px] leading-[40px] font-bold",
    h2: "text-[20px] leading-[28px] font-medium",
    body1: "text-[16px] leading-[24px]",
    body2: "text-[14px] leading-[20px]",
    label: "text-[14px] leading-[20px]",
  },

  shadows: {
    header: "shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12)]",
    footer: "shadow-[0px_-4px_12px_0px_rgba(0,0,0,0.12)]",
  },
} as const;
